import css from 'styled-jsx/css';

export default css`.login-agreement {
    :global(.ant-checkbox-wrapper) {
        font-size: 12px;
        line-height: 17px;
        color: #ccc;
    }
    :global(.ant-checkbox-wrapper span) {
        padding: 0;
    }
    :global(.ant-checkbox) {
        transform: scale(.8);
    }
    &-text {
        margin-left: 4px;
    }
    div {
        color: #ccc;
        font-size: 12px;
        line-height: 20px;
        a {
            color: #FF6400;
        }
    }
}

.login-agreement-modal {
    margin-top: 16px;
    text-align: center;
}

.login-agreement-component {
    padding: 0 24px;
    margin-top: 6px;
    text-align: left;
}
`